import React from 'react'; 

function Badge(props){

    return(  
        <p className='badgeSelects my-1 me-2'>
            <div className='centrarContainer'>
                {props.text}
            </div>
        </p>
    );
}


export default Badge;